import { makeFieldValueDbModule } from '../makeFieldValueDbModule';
import { clear as issueVerificationItemsServiceClear } from './issueVerificationItemsService';
import { makeClearPublisher } from 'serviceWorker/broadcasts/publishers';
import { fieldValueContracts } from 'shared/domain/fieldValue/fieldValueContracts';
import { EditableFieldValuesEntityName } from 'shared/domain/fieldValue/fields';

export const {
  clear,
  quantity,
  get,
  getOne,
  addBatch,
  updateBatch,
  removeBatch,
} = makeFieldValueDbModule({
  tableName: 'issueVerificationItems',
  serviceTableName: 'issueVerificationItemsService',
  serviceClearFunction: issueVerificationItemsServiceClear,
  broadcastClearFunction: makeClearPublisher(fieldValueContracts[EditableFieldValuesEntityName.issueVerificationItem]),
});
